import { Injectable } from '@angular/core';
import {ApiService} from '../../../core/service/api.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class ActionHistoryService {

  constructor(private api:ApiService) { }

  getList(criteria:Object):Observable<any>{
    return this.api.get('vna/action-history',criteria)
  }

  postAction(data:Object):Observable<any>{
      return this.api.post('vna/action-history',data)
  }

  putAction(element:any):Observable<any>{
    return this.api.put('vna/action-history',element.pk,element)
  }

  removeAction(pk:any):Observable<any>{
    return this.api.remove('vna/action-history',pk)
  }



}



// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/components/action-history/action-history.service.ts